import React from 'react';

export const NoDataMenuItem = () => {
  return <div></div>;
};
